import { ToolTipButtonFieldType } from "shared/types";
import IconButton from "./IconButton";
import { useState } from "react";
import BottomSheet from "shared/components/common/BottomSheet";
import "styles/components/forms/buttons/tooltipButton.css";

const ToolTipButton = ({
  id,
  title = "",
  value = "",
}: ToolTipButtonFieldType) => {
  const [isDraggableOpen, setIsDraggableOpen] = useState(false);

  const onClickHandler = () => {
    setIsDraggableOpen(!isDraggableOpen);
  };

  return (
    <>
      <IconButton
        onClickHandler={onClickHandler}
        wrapperClass={id}
        id={id}
        iconName="InfoCircle"
      />

      <BottomSheet
        isOpen={isDraggableOpen}
        onClose={() => setIsDraggableOpen(false)}
        title={title}
      >
        <div className="tooltip-container">
          {/* Support spliting text when see \n in json + support tags like <b>..</b> */}
          {value.split("\n").map((line, index) => (
            <div key={index} dangerouslySetInnerHTML={{ __html: line }}></div>
          ))}
        </div>
      </BottomSheet>
    </>
  );
};

export default ToolTipButton;
